import { render, staticRenderFns } from "./ListDetailV3.vue?vue&type=template&id=67dd8d1d&scoped=true&"
import script from "./ListDetailV3.vue?vue&type=script&lang=ts&"
export * from "./ListDetailV3.vue?vue&type=script&lang=ts&"
import style0 from "./ListDetailV3.vue?vue&type=style&index=0&id=67dd8d1d&lang=scss&scoped=true&"
import style1 from "./ListDetailV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd8d1d",
  null
  
)

export default component.exports